module.exports = __webpack_public_path__ + "static/media/Singh, Justin.20abe505.pdf";